import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
function NumberFormatCustom(props) {
  const { name, inputRef, onChange,  ...other } = props;  
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            value: values.value,
            name: name,
          },
        });
      }}
      thousandSeparator 
      // prefix="$" //đơn vị
    />
  );
}  
NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};
NumberFormatCustom.defaultProps = {
  name:  'price'
}
export default NumberFormatCustom; 

 